





































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFamilyStore } from "@/employee/store/family";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { OnboardingBalanceTransfer as BalanceTransferRoute } from "@/employee/route-names";

@Component
export default class FinishV2 extends Vue {
  portalCustomizationStore = usePortalCustomizationStore();
  familyStore = useFamilyStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlags = useFeatureFlagStore();

  mounted (): void {
    if (!this.familyStore.isFamilyStateLoaded) {
      this.familyStore.initialize();
    }
    else {
      this.$emit("complete");
    }
  }

  @Prop() routeToFinish;

  @Watch("familyStore.isFamilyStateLoaded")
  onStateChange (payLoad) {
    if (payLoad) {
      this.$emit("complete");
    }
  }

  get isLoaded () {
    return this.familyStore.isFamilyStateLoaded;
  }

  get transferOrRolloverHsaFundsUrl () {
    return this.custodianSettingsStore.transferOrRolloverHsaFundsUrl;
  }

  get routeToBalanceTransfer () {
    return { name: BalanceTransferRoute };
  }

  get showTransferButton () {
    return this.featureFlags.flags.bend28006BalanceTransfer;
  }
}
